import React from 'react'
import {Link, useHistory} from "react-router-dom";
import { Button } from 'reactstrap';
import DataTable from "../core/ui/data-table";
import FormatDateTime from "../core/utils/FormatDateTime";



export default function AdminRoyaltyPricing() {
  const history = useHistory();

  const table_columns = [
    { header: 'Source', key: 'source', render: (value) => value.royalty_source.name},
    { header: 'Product', key: 'product', render: (value) => value.royalty_product.name},
    { header: 'Subproduct', key: 'subproduct', render: (value) => value.royalty_subproduct.name},
    { header: 'Channel Option', key: 'channel_option', render: (value) => value.channel_option.name},
    { header: 'Billing Code', key: 'billing_codes', render: (value) => displayBillingCodes(value.billing_codes)},
    { header: 'Effective Date', key: 'effective_date', render: (value) => <FormatDateTime date={value.effective_date} />},
    { header: 'Cost Per Record', key: 'cost_per_record', render: (value) => value.cost_per_record},
  ];

  const displayBillingCodes = (_codes) => {
    if(!_codes || !_codes.length) return null;
    const codes_list = _codes.map(val => val.code);

    return (
      <div>
        {codes_list.map((item, index) => (
          <div className="fw-normal" key={index}>{item}</div>
        ))}
      </div>
    );
  }

  const table_actions = (royalty) =>
    <React.Fragment>
      <ul id="action-menu" className="action-menu">
        <Link to={'/admin-royalty-edit-form#royalty_id='+ royalty.id}> <i className="bi bi-pencil"></i>Edit</Link>
        &nbsp;&nbsp;
        <Link to={'/admin-royalty-edit-form#royalty_id='+ royalty.id +'&clone=true'}> <i className="bi bi-copy"></i>Clone</Link>
      </ul>
    </React.Fragment>;
  

  function onClickAdmin(ev) {
    ev.stopPropagation();
    history.push('/admin');
  }

  function onClickNew(ev) {
    ev.stopPropagation();
    history.push('/admin-royalty-form');
  }

  function onClickSettings(ev) {
    ev.stopPropagation();
    history.push('/admin-royalty-settings-form');
  }

  return (
    <div className="page admin-page admin-royalty-cost-page">
        <div className="list-header sticky-page-header">
          <Button className='new-button' onClick={onClickAdmin}><i className="bi bi-chevron-left"></i> Admin</Button>
          <h1>Royalty Cost</h1><i className="spacer"/>
          <Button className='new-button' onClick={onClickSettings}>Royalty Settings</Button>
          <Button className='new-button' onClick={onClickNew}>New Royalty Cost</Button>
        </div>

        <DataTable query='admin/royalty_costs'
                    cols={table_columns}
                    actions={table_actions}
                    empty='No Royalty Costs Found' />
   
    </div>
  )


}
